<template>
  <div>
    <div class="row mb-2">
      <div class="col-sm-3 col-xs-6" style="display: flex;">
        <select
          class="pagination-select"
          id="per-page"
          v-model="perPage"
          v-show="dataLength > 0"
        >
          <option :value="5">5</option>
          <option :value="10">10</option>
          <option :value="20">20</option>
        </select>

        <slot name="toolbar"></slot>
      </div>
      <div class="col-sm-3 col-xs-6">
        <div style="display: flex;">
          <input
            type="text"
            aria-controls="table-staff"
            class="form-control input-small"
            v-tooltip="{
              content: $label('user.users_search_tooltip', 'Name or email'),
              classes: 'custom-tooltip'
            }"
            :placeholder="$label('user.users_search_placeholder', 'Search...')"
            v-model="searchFilter"
          />
          <slot name="ext-search-button"></slot>
        </div>
      </div>
      <div class="col-sm-6 col-xs-12" v-show="dataLength > 0">
        <div
          class="dataTables_paginate paging_bootstrap_full_number"
          style="text-align: right;"
        >
          <ul class="pagination mt-0" style="visibility: visible;">
            <li class="prev" :class="{ disabled: disabledFirstPage }">
              <a
                @click="goToFirstPage"
                v-tooltip="{
                  content: $label('common.first_page', 'First page'),
                  classes: 'custom-tooltip'
                }"
                ><i class="fa fa-angle-double-left"></i
              ></a>
            </li>
            <li class="prev" :class="{ disabled: disabledPreviousPage }">
              <a
                @click="goToPreviousPage"
                v-tooltip="{
                  content: $label('common.back'),
                  classes: 'custom-tooltip'
                }"
                ><i class="fa fa-angle-left"></i
              ></a>
            </li>
            <li class="active">
              <a>{{ currentPage }}</a>
            </li>
            <li class="next" :class="{ disabled: disabledNextPage }">
              <a
                @click="goToNextPage"
                v-tooltip="{
                  content: $label('common.next', 'Next'),
                  classes: 'custom-tooltip'
                }"
                ><i class="fa fa-angle-right"></i
              ></a>
            </li>
            <li class="next" :class="{ disabled: disabledLastPage }">
              <a
                @click="goToLastPage"
                v-tooltip="{
                  content: $label('common.last_page', 'Last page'),
                  classes: 'custom-tooltip'
                }"
                ><i class="fa fa-angle-double-right"></i
              ></a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="row mt-8">
      <div class="col-xs-12">&nbsp;</div>
    </div>

    <div class="row" v-show="dataLength > 0 && !loading">
      <div class="col-xs-12">
        <div class="popup-wrapper">
          <div class="table-responsive">
            <fieldset>
              <table
                class="table dataTable table-striped table-bordered table-hover mb-1"
                :id="id ? id : 'table'"
              >
                <thead>
                  <tr>
                    <th
                      class="v-align-center text-center v-form v-form-disable checkbox-fixed-width"
                      v-if="selectable"
                    >
                      <label class="hidden-xs checkbox v-table-checkbox-label">
                        <input
                          type="checkbox"
                          class="group-checkable v-table-checkbox"
                          :data-set="`#` + id ? id : 'table' + '.checkboxes'"
                        /><i></i>
                      </label>
                    </th>
                    <th
                      v-for="(column, index) in columns"
                      :key="'th-' + index"
                      class="text-center"
                    >
                      {{ column.title ? column.title : "" }}
                      <i class="fa fa-caret-down" v-show="column.sorting"></i>
                    </th>
                    <th v-if="actions.length" class="text-center">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, index) in data" :key="'table-row-' + index">
                    <td
                      class="v-align-center v-table v-form v-form-disable sorting_1"
                      v-if="selectable"
                    >
                      <label class="hidden-xs checkbox v-table-checkbox-label">
                        <input
                          type="checkbox"
                          class="checkboxes v-table-checkbox"
                          name="selected_account_ids[]"
                          @click="$emit('onRowSelect', row)"
                        /><i></i>
                      </label>
                    </td>
                    <td
                      class="v-align-center text-center"
                      :class="{
                        'item-link': !!column.onClick
                      }"
                      v-for="(column, idx) in columns"
                      :id="
                        column.id && typeof column.id === 'function'
                          ? column.id(row)
                          : 'table-row-' + index + '-table-cell-' + idx
                      "
                      :key="'table-row-' + index + '-table-cell-' + idx"
                      @click="
                        () => {
                          if (
                            column.onClick &&
                            typeof column.onClick === 'function'
                          ) {
                            column.onClick(row);
                          }
                        }
                      "
                      v-tooltip.top-center="
                        column.tooltip
                          ? typeof column.tooltip === 'function'
                            ? column.tooltip(row)
                            : column.tooltip
                          : ''
                      "
                    >
                      <i
                        :class="
                          `text-${
                            column.iconColor ? column.iconColor : 'primary'
                          } fa fa-${
                            column.iconSize ? column.iconSize : 'lg'
                          } fa-fw fa-${column.icon}`
                        "
                        v-if="column.icon"
                      ></i>
                      {{
                        column.field
                          ? row[column.field]
                          : column.value && typeof column.value === "function"
                          ? column.value(row)
                          : ""
                      }}
                    </td>
                    <td
                      v-if="actions.length"
                      class="text-center min-width-auto"
                    >
                      <div class="btn-group">
                        <a
                          v-for="(action, index) in actions"
                          :key="'action-button-' + index"
                          :class="
                            action.bgColor
                              ? 'btn-' + action.bgColor
                              : {
                                  'btn-primary': action.type === 'envelope',
                                  'btn-default': action.type === 'detail',
                                  'btn-danger': action.type === 'delete',
                                  'is-disabled':
                                    action.disabled &&
                                    typeof action.disabled === 'function' &&
                                    action.disabled(row)
                                }
                          "
                          class="btn btn-sm"
                          :id="
                            action.id && typeof action.id === 'function'
                              ? action.id(row)
                              : 'action-button-' + index
                          "
                          @click="
                            () => {
                              if (
                                action.onClick &&
                                typeof action.onClick === 'function'
                              ) {
                                action.onClick(row);
                              }
                            }
                          "
                          v-tooltip.top-center="
                            action.tooltip
                              ? typeof action.tooltip === 'function'
                                ? action.tooltip(row)
                                : action.tooltip
                              : action.type === 'detail'
                              ? 'Details'
                              : ''
                          "
                        >
                          <i
                            :class="
                              action.icon
                                ? `fa fa-${
                                    action.iconSize ? action.iconSize : 'lg'
                                  } fa-fw fa-${action.icon}`
                                : {
                                    'text-primary fa-eye':
                                      action.type === 'detail',
                                    'fa-trash': action.type === 'delete',
                                    'fa-lg fa-envelope-o':
                                      action.type === 'envelope'
                                  }
                            "
                            class="fa fa-fw"
                          ></i
                          >&nbsp;
                          <template v-if="action.label">{{
                            action.label
                          }}</template>
                          <template v-else>
                            <template v-if="action.type === 'delete'"
                              >Delete</template
                            >
                            <template v-if="action.type === 'detail'"
                              >Details</template
                            >
                          </template>
                        </a>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
    <alert-box
      v-show="!loading && dataLength < 1 && dataLength != null"
      type="warning"
      id="alert-no-data"
      :closeable="false"
      :show-icon="false"
    >
      {{ $label("common.no_data_exist", "No data exist.") }}
    </alert-box>
    <div v-show="loading" class="row">
      <div class="col-xs-12">
        <view-loader
          margin-top-pixels="15"
          border-color="primary"
        ></view-loader>
      </div>
    </div>
    <div class="row" v-show="dataLength > 0">
      <div class="col-sm-6 col-xs-12 dataTables_info">
        {{ from }} - {{ to }} {{ $label("common.pagination_of", "of") }}
        {{ total }}
      </div>
      <div class="col-sm-6 col-xs-12">
        <div
          class="dataTables_paginate paging_bootstrap_full_number"
          style="text-align: right;"
        >
          <ul class="pagination" style="visibility: visible;">
            <li class="prev" :class="{ disabled: disabledFirstPage }">
              <a
                @click="goToFirstPage"
                v-tooltip="{
                  content: $label('common.first_page', 'First page'),
                  classes: 'custom-tooltip'
                }"
                ><i class="fa fa-angle-double-left"></i
              ></a>
            </li>
            <li class="prev" :class="{ disabled: disabledPreviousPage }">
              <a
                @click="goToPreviousPage"
                v-tooltip="{
                  content: $label('common.back'),
                  classes: 'custom-tooltip'
                }"
                ><i class="fa fa-angle-left"></i
              ></a>
            </li>
            <li class="active">
              <a>{{ currentPage }}</a>
            </li>
            <li class="next" :class="{ disabled: disabledNextPage }">
              <a
                @click="goToNextPage"
                v-tooltip="{
                  content: $label('common.next', 'Next'),
                  classes: 'custom-tooltip'
                }"
                ><i class="fa fa-angle-right"></i
              ></a>
            </li>
            <li class="next" :class="{ disabled: disabledLastPage }">
              <a
                @click="goToLastPage"
                v-tooltip="{
                  content: $label('common.last_page', 'Last page'),
                  classes: 'custom-tooltip'
                }"
                ><i class="fa fa-angle-double-right"></i
              ></a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ViewLoader from "@/components/Common/ViewLoader.vue";
import AlertBox from "@/components/Common/Alerts/AlertBox";

export default {
  components: { ViewLoader, AlertBox },

  props: {
    id: {
      type: String,
      default: ""
    },
    loading: {
      type: Boolean,
      default: false
    },
    actions: {
      type: Array,
      default: () => []
    },
    columns: {
      type: Array,
      default: () => []
    },
    data: {
      type: Array,
      default: () => []
    },
    selectable: {
      type: Boolean,
      default: false
    },
    meta: {
      type: Object,
      default: () => ({
        current_page: 1,
        from: 1,
        last_page: 1,
        per_page: 20,
        to: 1,
        total: 1
      })
    }
  },

  data() {
    return {
      dataLength: null,
      currentPage: 1,
      total: 0,
      from: 0,
      to: 0,
      firstPage: 1,
      lastPage: null,
      perPage: null,
      searchFilter: "",
      sortBy: "",
      sortOrder: "asc",
      debounce: null
    };
  },

  methods: {
    refetch() {
      this.$emit("fetchQuery", {
        page: this.currentPage,
        per_page: this.perPage,
        search: this.searchFilter,
        sort_by: this.sortBy,
        sort_order: this.sortOrder,
        to: this.to
      });
    },

    goToFirstPage() {
      if (!this.disabledFirstPage) {
        this.currentPage = 1;
        this.refetch();
      }
    },

    goToPreviousPage() {
      if (!this.disabledPreviousPage) {
        this.currentPage--;
        this.refetch();
      }
    },

    goToNextPage() {
      if (!this.disabledNextPage) {
        this.currentPage++;
        this.refetch();
      }
    },

    goToLastPage() {
      if (!this.disabledLastPage) {
        this.currentPage = this.lastPage;
        this.refetch();
      }
    }
  },
  computed: {
    disabledFirstPage() {
      return this.currentPage === 1;
    },

    disabledPreviousPage() {
      return this.currentPage === 1;
    },

    disabledNextPage() {
      return this.currentPage === this.lastPage;
    },

    disabledLastPage() {
      return this.currentPage === this.lastPage;
    }
  },
  watch: {
    meta(meta) {
      this.currentPage = meta.current_page;
      this.total = meta.total;
      this.from = meta.from;
      this.to = meta.to;
      this.lastPage = meta.last_page;
      this.perPage = parseInt(meta.per_page, 10);
    },
    data(data) {
      this.dataLength = data.length;
    },
    perPage() {
      this.refetch();
    },
    searchFilter() {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.refetch();
      }, 600);
    },
    sortBy() {
      this.refetch();
    },
    sortOrder() {
      this.refetch();
    }
  }
};
</script>

<style>
.mt-0 {
  margin-top: 0rem !important;
}

.mt-8 {
  margin-top: 1.3rem;
}

.mb-0 {
  margin-bottom: 0rem;
}

.mb-1 {
  margin-bottom: 0.3rem;
}

.mb-2 {
  margin-bottom: 0.6rem;
}

.mb-8 {
  margin-bottom: 1.3rem;
}

.checkbox-fixed-width {
  width: 50px;
}

.min-width-auto {
  width: 50px;
}

.pagination-select {
  font-weight: 700;
  height: 34px;
  padding-left: 10px;
  width: 70px;
  cursor: pointer;
  border: 1px solid #ddd;
  color: #666;
  outline: none;
}

.item-link:hover {
  color: #3aa94c;
  cursor: pointer;
}
</style>
